var _path, _path2, _path3, _path4, _path5, _ellipse, _rect, _rect2, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.94959 6.27039C1.94959 5.77554 2.35074 5.37439 2.84559 5.37439H21.4399C21.9348 5.37439 22.3359 5.77554 22.3359 6.27039V20.1913C22.3359 20.6862 21.9348 21.0873 21.4399 21.0873H2.84559C2.35074 21.0873 1.94959 20.6862 1.94959 20.1913V6.27039Z",
    stroke: "#081E54",
    strokeWidth: 0.448
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.014 2.87891C16.1377 2.87891 16.238 2.97919 16.238 3.10291L16.238 3.45608L8.1358 3.45608L8.1358 3.10291C8.1358 2.97919 8.23608 2.87891 8.3598 2.87891L16.014 2.87891Z",
    fill: "#081E54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2383 3.4579L16.2383 6.92368L15.6595 6.92368L15.6595 3.28516L16.2383 3.4579Z",
    fill: "#081E54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71484 3.35547L8.71484 6.53109L8.13611 6.53109L8.13611 3.35662L8.71484 3.35547Z",
    fill: "#081E54"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.72559 6.18116C1.72559 5.68631 2.12674 5.28516 2.62159 5.28516H21.3438C21.5665 5.28516 21.7812 5.36807 21.9461 5.51775L22.0613 5.62236C22.2274 5.77319 22.3309 5.98088 22.3513 6.20435L22.5599 8.49044H1.72559V6.18116Z",
    fill: "#E7EDFF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.1419,
    cy: 14.384,
    rx: 4.05112,
    ry: 4.04023,
    fill: "#081E54"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.708,
    y: 12.6582,
    width: 0.868097,
    height: 3.46306,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8789,
    y: 13.957,
    width: 0.865764,
    height: 3.47239,
    transform: "rotate(90 13.8789 13.957)",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.72559 6.27039C1.72559 5.65183 2.22703 5.15039 2.84559 5.15039H21.4399C22.0585 5.15039 22.5599 5.65183 22.5599 6.27039V20.1913C22.5599 20.8099 22.0585 21.3113 21.4399 21.3113H2.84559C2.22703 21.3113 1.72559 20.8099 1.72559 20.1913V6.27039Z",
    stroke: "#081E54"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/Medical.97e223ef97a5db3e33d2253b914621a0.svg";
export { ForwardRef as ReactComponent };